import {useField} from 'formik'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import usePrevious from '../../../helpers/usePrevious'
import parse from 'html-react-parser'
import unescape from 'lodash/unescape'

const InfoModal: React.FC = () => {
    const [queue, setQueue] = useState<string[]>([])
    const [field] = useField('modal_info')
    const {value} = field
    const previousFieldValue = usePrevious(value)

    useEffect(() => {
        if (Array.isArray(value) && value.length) {
            const prevLen = Array.isArray(previousFieldValue) ? previousFieldValue.length : 0

            const newItems = value.slice(prevLen)
            if (newItems.length) {
                setQueue((q) => [...q, ...newItems])
            }
        }
    }, [value])

    const current = queue[0] ?? null

    const handleClose = () => {
        setQueue((q) => q.slice(1))
    }

    return (
        <Modal
            show={!!current}
            onHide={handleClose}
            size='xl'
            centered
            onEntering={
                /* setModalIndex */ () => {
                    const backdropsList =
                        document.body.getElementsByClassName('modal-backdrop show')
                    const modalsList = document.body.getElementsByClassName('modal show')
                    const currentBackdrop = backdropsList[backdropsList.length - 1]
                    const currentModal = modalsList[modalsList.length - 1]
                    currentBackdrop.setAttribute('style', `z-index: 2010`)
                    currentModal.setAttribute('style', `display: block; z-index: 2013`)
                }
            }
        >
            <Modal.Header closeButton>
                <Modal.Title>Информационное окно</Modal.Title>
            </Modal.Header>
            <Modal.Body>{current && parse(unescape(current))}</Modal.Body>
        </Modal>
    )
}

export default InfoModal
